<template>
     <div ref="box" class="row inputBox" :style="{minWidth: min}" style="position: relative;">
      
          <input
              style="width: 100%; margin: 0; transition: none; padding-right: 0px;"
              ref="input"              
              type="number"
              v-model.number="value"
              :placeholder="placeholder || '0'"   
              @blur="update"
              @input="update();$refs.box.style.width = ($event.target.value.length + 7) + 'ch'">

              <p v-if="$slots.default" class="label"><slot></slot></p>        
      </div>

        <!-- 
          <Number v-model="year" placeholder="Year" class="w300">mm</Number>
         -->
</template>
<script>
export default {
   
    data: function () {return {
      value: this.modelValue,      
    }},

    props: {
      modelValue: Number,
      placeholder: String,
      min:{type: String, default:'100px'}
    },

    watch: {
      modelValue: {
        handler(val){ this.value = val},
      }
    },

    methods: {

       update() {
        if (isNaN(this.value)) return
        this.$emit('update:modelValue', this.value)          
      },
      

    },
}
</script>

<style scoped>
.label{
  position: absolute;
  right: 12px;
  top: 11px;
  /* font-family: monospace; */
  /* font-weight: 700; */
  font-size: 14px;
  padding-left: 9px;
  border-left: 0.5px solid var(--g1);
  text-align: right;

}
.selects{
  position: absolute;
right: 0px;
height: 100%;
border-radius: 0;
width: 55px;
width: -moz-fit-content;
width: fit-content;
padding: 0px;
background: none;
opacity: 0;
}

    .inputBox{
      /* margin: 0px 0 12px; */
      /* margin: 0px 0 0px; */
    }

  .input{
    padding: 5px 12px 8px;      
    border-radius: 8px;
    background: var(--g05);
  }
  
  .clear{
    background:none;
  }

  .inputIcon{
    padding-left: 50px;      
  }

  .icon{
    height: 20px;
    width: auto;
    position: absolute;
    top: 11px;
    left: 12px;
    border-radius: 4px;
  }
  .clearicon{
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    width: 22px;
    position: absolute;
    top: 11px;
    right: 7px;
    border-radius: 100px;
    background-color: var(--g1);
    
  }
  .clearicon span{
    position: absolute;
    font-size: 12px;
    font-weight: 500;
    color: var(--g3);
    margin-top: -1px;
  }

  .iconpadding{
    padding-left: 30px;
  }

</style>

